module.exports = __webpack_public_path__ + "media/images/lb/088-aaa69a11e8765e4d178ce0fa7214e5d2.svg";